import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/endpoints';
import {
  ChangePasswordRequest,
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  ResendVerificationRequest,
  UpdatePasswordRequest,
  UpdateProfileRequest,
  UpdateProfileResponse,
  UserProfile,
  VerifyEmailRequest,
  VerifyEmailResponse,
} from '../types/profile.types';

export const profileService = {
  /**
   * Get current user profile
   */
  getProfile: async (): Promise<UserProfile> => {
    const response = await apiClient.get<UserProfile>(API_ENDPOINTS.ME);
    return response.data;
  },

  /**
   * Update user profile
   */
  updateProfile: async (data: UpdateProfileRequest): Promise<UpdateProfileResponse> => {
    const response = await apiClient.post<UpdateProfileResponse>(
      API_ENDPOINTS.ME,
      data
    );
    return response.data;
  },

  /**
   * Update password
   */
  updatePassword: async (data: UpdatePasswordRequest): Promise<{ message: string }> => {
    const response = await apiClient.post<{ message: string }>(
      API_ENDPOINTS.ME_PASSWORD,
      data
    );
    return response.data;
  },

  /**
   * Change password (legacy alias)
   */
  changePassword: async (data: ChangePasswordRequest): Promise<void> => {
    await profileService.updatePassword(data);
  },

  /**
   * Request password reset
   */
  forgotPassword: async (data: ForgotPasswordRequest): Promise<ForgotPasswordResponse> => {
    const response = await apiClient.post<ForgotPasswordResponse>(
      API_ENDPOINTS.FORGOT_PASSWORD,
      {
        userId: data.email,
      }
    );
    return response.data;
  },

  /**
   * Reset password using token from email link
   */
  resetPassword: async (data: ResetPasswordRequest): Promise<ResetPasswordResponse> => {
    const response = await apiClient.post<ResetPasswordResponse>(
      API_ENDPOINTS.RESET_PASSWORD,
      data
    );
    return response.data;
  },

  /**
   * Verify email with token (GET with query params)
   */
  verifyEmail: async (data: VerifyEmailRequest): Promise<VerifyEmailResponse> => {
    const response = await apiClient.get<VerifyEmailResponse>(
      API_ENDPOINTS.VERIFY_EMAIL,
      {
        params: {
          token: data.token,
          userId: data.userId,
          tenantId: data.tenantId,
        },
      }
    );
    return response.data;
  },

  /**
   * Resend verification email
   */
  resendVerification: async (_data: ResendVerificationRequest): Promise<void> => {
    throw new Error('Resend verification endpoint not available for regular users');
  },
};
